export const messages = {
  en: {
    adminRefundGroupOrder: {
      queryCondition: 'Query Conditions',
      groupRefundOrder: 'Group Refund Orders',
      returnId: 'Refund ID',
      order: 'Order',
      product: 'Product',
      buyer: 'Buyer',
      buyCount: 'Quantity',
      groupPrice: 'Group Price',
      refundAmount: 'Refund Amount',
      refundType: 'Refund Type',
      refundReason: 'Refund Reason',
      status: 'Status',
      auditDesc: 'Audit Description',
      query: 'Query',
      all: 'All',
      selfRefund: 'Self Refund',
      groupFailRefund: 'Group Fail Refund',
      returnIdPlaceholder: 'Please enter refund ID',
      orderIdPlaceholder: 'Please enter order ID',
      returnTypePlaceholder: 'Please select refund type',
      shop: 'Shop',
      refundNo: 'Refund No',
      buyQuantity: 'Buy Quantity',
      auditRemark: 'Audit Remark'
    },
    adminShop: {
      all: 'All'
    }
  },
  zh: {
    adminRefundGroupOrder: {
      queryCondition: '查询条件',
      groupRefundOrder: '拼团退单',
      returnId: '退单编号',
      order: '订单',
      product: '商品',
      buyer: '购买人',
      buyCount: '购买数量',
      groupPrice: '拼团价格',
      refundAmount: '退款金额',
      refundType: '退款类型',
      refundReason: '退款原因',
      status: '状态',
      auditDesc: '审核说明',
      query: '查询',
      all: '全部',
      selfRefund: '自主退款',
      groupFailRefund: '拼团失败退款',
      returnIdPlaceholder: '请输入退单ID',
      orderIdPlaceholder: '请输入订单ID',
      returnTypePlaceholder: '请选择退款类型',
      shop: '店铺',
      refundNo: '退单编号',
      buyQuantity: '购买数量',
      auditRemark: '审核说明'
    },
    adminShop: {
      all: '全部'
    }
  }
}